<div class="bg-dark rounded p-3">
  <div class="" (mouseleave)="setActiveStar(0)">
    <i class="fa fa-star fa-2x" *ngFor="let star of [1, 2, 3, 4, 5]"
      (mouseenter)="setActiveStar(star)" [ngClass]="{ 'active': activeStar! >= star, 'pe-2': star <= 4 }"
      (click)="vote(star)"></i>
  </div>
</div>
